<template>
    <div class="container">
    
    </div>
</template>

<script>
export default {
    name: "MenuPreview",
    // 组件
    components: {},
    props: {},
    data() {
        return {};
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        getDeviceType () {
            let id = this.$route.params.id
            if (!id) {
                this.$router.replace({path: '/404'})
                return
            }
            if (window.screen.width > 500) {
                this.$router.replace({path: `/menu-pc/${id}`})
            } else {
                this.$router.replace({path: `/menu-mobile/${id}`})
            }
        }
    },
    // 创建完成
    created() {
        this.getDeviceType()
    },
    // 挂载完成
    mounted() {
    
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>

</style>
